window.o_global = window.o_global || {};

/**
 * Class to handle global onReady and onLoad functions in a specific priority order.
 *
 * @class
 */
o_global.EventLoader = function() {
    "use strict";

    this.readyQueue = [];
    this.loadQueue = [];
    this.allScriptsExecutedQueue = [];
    this.onReadyFired = false;
    this.onLoadFired = false;
    this.allScriptsExecutedFired = false;
};

/**
 * Sort a given array of objects ascending by their priority value.
 * Modifies the original Array due to copy by reference.
 *
 * @param {Array} queue Array of objects to sort.
 *
 * @return {Array} Sorted array.
 */
o_global.EventLoader.prototype.sortByPriority = function(queue) {
    "use strict";

    return queue.sort(function(a, b) {
        return a.priority - b.priority;
    });
};

/**
 * Abstract handling of onReadyQueue, due to multiple occurrences.
 */
o_global.EventLoader.prototype.handleOnReadyQueue = function() {
    "use strict";

    this.onReadyFired = true;
    this.readyQueue = this.sortByPriority(this.readyQueue);

    for (var i = 0; i < this.readyQueue.length; i += 1) {
        this.readyQueue[i].fn();
    }
};

/**
 * Handle functions registered on "document ready".
 */
o_global.EventLoader.prototype.initOnReady = function() {
    "use strict";

    var that = this;

    document.addEventListener("DOMContentLoaded", function() {
        that.handleOnReadyQueue();
    }, false);
};

/**
 * Handle functions registered on window.onload.
 * Preserves prior window.onload functions.
 */
o_global.EventLoader.prototype.initOnLoad = function() {
    "use strict";

    var that = this,
        oldOnLoadFunction = window.onload;

    /**
     * Encapsulate functionality that will be executed on window.onload.
     */
    function onLoadFunction() {
        that.onLoadFired = true;
        that.loadQueue = that.sortByPriority(that.loadQueue);

        for (var i = 0; i < that.loadQueue.length; i++) {
            that.loadQueue[i].fn();
        }
    }

    // Preserve former window.onload functions.
    if (typeof window.onload !== "function") {
        window.onload = onLoadFunction;
    } else {
        window.onload = function() {
            if (oldOnLoadFunction) {
                oldOnLoadFunction();
            }

            onLoadFunction();
        };
    }
};

/**
 * Handle functions registered on AllScriptsExecuted.
 * Preserves prior AllScriptsExecuted functions.
 */
o_global.EventLoader.prototype.initOnAllScriptsExecuted = function() {
    "use strict";

    var that = this;

    document.addEventListener("AllScriptsExecuted", function() {
        that.allScriptsExecutedFired = true;
        that.allScriptsExecutedQueue = that.sortByPriority(that.allScriptsExecutedQueue);

        for (var i = 0; i < that.allScriptsExecutedQueue.length; i += 1) {
            that.allScriptsExecutedQueue[i].fn();
        }
    }, false);
};

/**
 * Add a function to the queue that will be execute on "document ready".
 * Executes the function directly if the document.readystatechange event was already fired.
 *
 * @param {Number} prio     Priority number to sort out execution order.
 * @param {Function} fn     Function that will be trigger on "document ready".
 */
o_global.EventLoader.prototype.onReady = function(prio, fn) {
    "use strict";

    if (!this.onReadyFired) {
        var loadItem = {};

        loadItem.priority = prio;
        loadItem.fn = fn;

        this.readyQueue.push(loadItem);
    } else {
        fn();
    }
};

/**
 * Add a function to the queue that will be execute on window.onload.
 * Executes the function directly if the onload event was already fired.
 *
 * @param {Number} prio     Priority number to sort out execution order.
 * @param {Function} fn     Function that will be trigger on load.
 */
o_global.EventLoader.prototype.onLoad = function(prio, fn) {
    "use strict";

    if (!this.onLoadFired) {
        var loadItem = {};

        loadItem.priority = prio;
        loadItem.fn = fn;

        this.loadQueue.push(loadItem);
    } else {
        fn();
    }
};

/**
 * Add a function to the queue that will be execute on allScriptsExecuted.
 * Executes the function directly if the onAllScriptsExecuted event was already fired.
 *
 * @param {Number} prio     Priority number to sort out execution order.
 * @param {Function} fn     Function that will be trigger on allScriptsExecuted.
 */
o_global.EventLoader.prototype.onAllScriptsExecuted = function(prio, fn) {
    "use strict";

    if (!this.allScriptsExecutedFired) {
        var item = {};

        item.priority = prio;
        item.fn = fn;

        this.allScriptsExecutedQueue.push(item);
    } else {
        fn();
    }
};

o_global.eventLoader = new o_global.EventLoader();

o_global.eventLoader.initOnReady();
o_global.eventLoader.initOnLoad();
o_global.eventLoader.initOnAllScriptsExecuted();
